import { isValid, parse } from 'date-fns';

export const PT_BR_DATE_FORMAT = 'dd/MM/yyyy';
export const EN_US_DATE_FORMAT = 'MM/dd/yyyy';

export function parseDate(value: string, primaryFormat: string): Date | null {
  const trimmed = value.trim();
  if (!trimmed) return null;

  const parsed = parse(trimmed, primaryFormat, new Date());
  return isValid(parsed) ? parsed : null;
}

export function applyDateMask(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 8);
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
}
